module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eYODE"))).then(() => parcelRequire('hEqeo'));